// deno-fmt-ignore-file
// deno-lint-ignore-file
import { Guard } from '../../guard/index.mjs';
import { IsKind } from './schema.mjs';
import { Deferred } from './deferred.mjs';
import { ParseTemplateIntoTypes } from '../engine/patterns/template.mjs';
import { Instantiate } from '../engine/instantiate.mjs';
/** Creates a deferred TemplateLiteral action. */
export function TemplateLiteralDeferred(types, options = {}) {
    return Deferred('TemplateLiteral', [types], options);
}
export function TemplateLiteralConstruct(types, options = {}) {
    return Instantiate({}, TemplateLiteralDeferred(types, options));
}
/** Creates a TemplateLiteral type. */
export function TemplateLiteral(input, options = {}) {
    const types = Guard.IsString(input) ? ParseTemplateIntoTypes(input) : input;
    return TemplateLiteralConstruct(types, options);
}
// ------------------------------------------------------------------
// Guard
// ------------------------------------------------------------------
/** Returns true if the given value is TTemplateLiteral. */
export function IsTemplateLiteral(value) {
    return IsKind(value, 'TemplateLiteral');
}
